// @flow

import { LOGIN_FAILURE, LOGIN_SUCCESS, LOGOUT } from "../actions"

export default ( state: any = {}, action: any ) => {
  switch ( action.type ) {
  case LOGIN_SUCCESS:
  case LOGIN_FAILURE:
    return {
      ...state,
      message: action.response.message,
      token: action.response.result,
      ok: action.type === LOGIN_SUCCESS,
    }
  case LOGOUT:
    return {
      message: "",
      ok: false,
    }
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.jsx